import React, { Component } from "react";
import { connect } from "react-redux";

import { getKeyByValue } from "../functions";

class ActiveLine extends Component {
  constructor(props) {
    super(props);
    this.state = {
      menu: { open: false },
    };
  }

  getActiveColor = () => {
    const { site } = this.props;
    return site.current && site.current.category
      ? site.current.category.acf.varvus
      : "#FF0000";
  };

  render() {
    return (
      <div
        className="ActiveLine"
        style={{ backgroundColor: this.getActiveColor() }}
      ></div>
    );
  }
}

const mapStateToProps = (state) => ({
  site: state.site,
});

export default connect(mapStateToProps, {})(ActiveLine);
